module.exports = __webpack_public_path__ + "static/media/5-2.ada8de86.jpg";